import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FieldConfig } from "../../models/field.interface";
import * as _ from 'lodash';
import { ValidationService, ValidationType } from '../../services/validation.service';
import { IncidentsFormsService } from '../../services/incidents-forms.service';

@Component({
  selector: 'app-incidents-list',
  template: `
  <div [formGroup]="group" *ngIf="field.style.visibility">
  <div class="hazard-description radio-buttons multi-slect-radiolist">
    <p class="dynamic-paragraph">{{field.name}}<b *ngIf="field.validation.isRequired">*</b></p>
    <div class="dropdown">
      <button data-toggle="dropdown" [ngClass]="{'pointer-events' : !field.style.editability}" aria-haspopup="true" aria-expanded="false" type="button">
        <span [ngClass]="{'fr-slect' : selectValue}">{{(selectValue) ? selectValue : 'Select'}}</span>
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu">
        <li>
          <input class="form-control" placeholder="search" [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}">
        </li>
        <li>
          <mat-radio-group class="example-radio-group" *ngFor="let item of field.data | keys | multiChoiceList:searchText;let i = index">
            <mat-radio-button class="example-radio-button" (change)="onChange(item)" [checked]="selected() === item.key" [value]="item.key">
              {{item.value}}
          </mat-radio-button>
          </mat-radio-group>
        </li> 
      </ul>
    </div>
    <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
  </div>
</div>
  `,
  styles: [`.multi-slect-radiolist {float: left;width: 98%;}.dropdown .fr-slect{text-transform : lowercase!important;}`]
})
export class IncidentsListComponent implements OnInit {

  field: FieldConfig;
  group: FormGroup;
  selectValue;
  constructor(
    private _validationService: ValidationService,
    private _incidentForms : IncidentsFormsService,
    private _activatedRoute: ActivatedRoute
  ) { }
  onChange(selectedItem) {
    let selectedOption = {};
    selectedOption[selectedItem.key] = selectedItem.value;
    this.field.value = selectedOption;
    this.selectValue = Object.values(this.field.value);
    this.field.value = {
      "taskId" : Object.values(this.field.value)[0],
      "_id" : Object.keys(this.field.value)[0]
    }
    this.group.value[this.field.id] = this.field.value;
    const data = this.group.value;
    this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onChange]);
  }
  selected() {
    if (this.field.value && this.field.value !== " ") {
      return this.field.value._id;
    }
  }
  ngOnInit() {
    const incidentId = this._activatedRoute.snapshot.queryParams.incident;
    const templateId = this._activatedRoute.snapshot.params.id;
    this._incidentForms.performPagination("fh_task_template:incidentform", 0, true, undefined)
    .subscribe(
      (res:any) => {
        if(res.data && res.data.length > 0){
          this.field.data = [];
          _.forEach(res.data , (val,i)=>{
            let data = {};
            // Update: 01/22/2026 : Displaying only open incidents to resolve form.
            // For RCA, all incidents can be shown. Match templateId with 'rootcauseform'
            let allowedStatus = [0];
            if (templateId === 'fh_task_template:rootcauseform') {
              allowedStatus = [0, 1, 2];
            }
            if(allowedStatus.indexOf(val.status) > -1){ 
              data[val._id] = val.taskId;
              // Auto-select if incident query param matches. scenario when user selects Resolve incident from the incident view form
              if (incidentId && val._id === incidentId) {
                this.onChange({ key: val._id, value: val.taskId });
                this.field.data.push(data);
              } else if (!incidentId) {
                this.field.data.push(data);
              }
            }

          })
        }
      },
      err => {
        console.log(err);
      }
    )
    if(this.field.value && this.field.value !== " "){
      this.selectValue = this.field.value.taskId;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/rFF/fields/incidents-list/incidents-list.component.ts